import React from "react";
import {
  Container,
  Typography,
  Box,
  Divider,
  Paper,
} from "@mui/material";
import { Helmet } from "react-helmet";
import Header from "../common/Header";
import Footer from "../common/Footer";

const TermsOfService: React.FC = () => {
  return (
    <div>
      <Helmet>
        <title>Terms of Service | Tranzcribe</title>
        <meta
          name="description"
          content="Terms of Service for Tranzcribe's AI-powered transcription service."
        />
      </Helmet>

      {/* Navigation Bar - Sticky */}
      <Header />

      {/* Content */}
      <Container maxWidth="md" sx={{ mt: 6, mb: 4, paddingBottom: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" gutterBottom>
            Terms of Service
          </Typography>
          <Typography color="textSecondary" sx={{ mb: 4 }}>
            Last updated: 6/3/2025
          </Typography>
          <Divider sx={{ mb: 4 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              1. Agreement to Terms
            </Typography>
            <Typography variant="body1" paragraph>
              By accessing and using Tranzcribe's services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing our service.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              2. Use License
            </Typography>
            <Typography variant="body1" paragraph>
              Permission is granted to temporarily access and use Tranzcribe's services for personal, non-commercial transitory viewing and transcription purposes only. This is the grant of a license, not a transfer of title.
            </Typography>
            <Typography variant="body1" paragraph>
              Under this license, you may not:
            </Typography>
            <ul>
              <li>
                <Typography variant="body1">Modify or copy the materials</Typography>
              </li>
              <li>
                <Typography variant="body1">Use the materials for any commercial purpose</Typography>
              </li>
              <li>
                <Typography variant="body1">Attempt to decompile or reverse engineer any software contained in Tranzcribe</Typography>
              </li>
              <li>
                <Typography variant="body1">Remove any copyright or other proprietary notations</Typography>
              </li>
              <li>
                <Typography variant="body1">Transfer the materials to another person or "mirror" the materials on any other server</Typography>
              </li>
            </ul>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              3. Service Description
            </Typography>
            <Typography variant="body1" paragraph>
              Tranzcribe provides AI-powered transcription services. While we strive for accuracy, we cannot guarantee 100% accuracy in all transcriptions. The service is provided "as is" and we reserve the right to modify or discontinue the service at any time.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              4. User Obligations
            </Typography>
            <Typography variant="body1" paragraph>
              You agree to:
            </Typography>
            <ul>
              <li>
                <Typography variant="body1">Provide accurate and complete information</Typography>
              </li>
              <li>
                <Typography variant="body1">Maintain the security of your account</Typography>
              </li>
              <li>
                <Typography variant="body1">Not use the service for any illegal purposes</Typography>
              </li>
              <li>
                <Typography variant="body1">Not upload content that infringes on others' rights</Typography>
              </li>
              <li>
                <Typography variant="body1">Not attempt to breach or test our security measures</Typography>
              </li>
            </ul>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              5. Payment Terms
            </Typography>
            <Typography variant="body1" paragraph>
              Certain aspects of the service may be provided for a fee. You agree to pay all fees in accordance with the pricing established for your selected plan. Fees are non-refundable except as required by law or as explicitly stated in our refund policy.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              6. Limitation of Liability
            </Typography>
            <Typography variant="body1" paragraph>
              Tranzcribe shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              7. Changes to Terms
            </Typography>
            <Typography variant="body1" paragraph>
              We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the service.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              8. Contact Information
            </Typography>
            <Typography variant="body1">
              Questions about the Terms of Service should be sent to us at support@tranzcribe.com.
            </Typography>
          </Box>
        </Paper>
      </Container>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TermsOfService; 